export const VERSION = '0.6.1';
//# sourceMappingURL=version.js.map